import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import UserProfile from "../components/pages/user-profile/UserProfile";
import CreateWork from "../components/pages/create-work/CreateWork";
import Work from "../components/pages/work/Work";
import NotFound from "../components/pages/not-found/NotFound";
import Subscription from "../components/pages/subscription/Subscription";
import Notifications from "../components/pages/notifications/Notifications";
import Applications from "../components/pages/applications/Applications";
import SavedWorks from "../components/pages/saved-works/SavedWorks";
import CreatedOrders from "../components/pages/created-orders/CreatedOrders";
import CompletedOrders from "../components/pages/completed-orders/CompletedOrders";

const AuthRoutes: FC = () => {
    return (
        <Routes>
            <Route path="/profile" element={<UserProfile />} />
            <Route path="/profile/:clientId" element={<UserProfile />} />
            <Route path="/create-work" element={<CreateWork />} />
            <Route path="/work" element={<NotFound />} />
            <Route path="/work/:id" element={<Work />} />
            <Route path="/*" element={<NotFound />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/applications" element={<Applications />} />
            <Route path="/created-orders" element={<CreatedOrders />} />
            <Route path="/completed-orders" element={<CompletedOrders />} />
            <Route path="/saved" element={<SavedWorks />} />
        </Routes>
    );
};

export default AuthRoutes;
